document.addEventListener('DOMContentLoaded', function() {
    
    // Navigation bar scroll functions

    let scrolled;
    const header = document.querySelector('.header');

    function scrollPage () {
        scrolled = window.pageYOffset || document.documentElement.scrollTop;
        scrolled > 100 ? header.classList.add('scrolled') : header.classList.remove('scrolled');
    }

    window.addEventListener('scroll', function() {
        scrollPage();
    });

    scrollPage();

    // Mobile hamburger menu & dropdown

    const btnContacts = document.querySelector('.btn__contacts');
    const dropdown = document.querySelector('.btn__contacts > .dropdown');
    const btnHamburger = document.querySelector('.btn__hamburger');
    const mobileNavi = document.querySelector('.navi');

    btnContacts.addEventListener('click', function(e) {
        this.classList.toggle('active');
        dropdown.classList.toggle('opened');
    });

    btnHamburger.addEventListener('click', function (e) {
        e.preventDefault();
        this.classList.toggle('active');
        mobileNavi.classList.toggle('opened');
    });

    window.addEventListener('click', (e) => {
        const target = e.target;
        if (!target.closest('.btn__contacts')) {
            dropdown.classList.remove('opened');
            btnContacts.classList.remove('active');
        }
        document.querySelectorAll('.btn__contacts > .dropdown > li > a').forEach((e) => {
            if (target == dropdown || target == e) {
                dropdown.classList.add('opened');
                btnContacts.classList.add('active');
            }
        });
        if (!target.closest('.btn__hamburger')) {
            mobileNavi.classList.remove('opened');
            btnHamburger.classList.remove('active');
        }
        document.querySelectorAll('.navi > li > a').forEach((e) => {
            if (target == mobileNavi || target == e) {
                mobileNavi.classList.add('opened');
                btnHamburger.classList.add('active');
            }
        });
    });

    // Masked phone number

    const im = new Inputmask('+38 (099) 999-99-99', { 'placeholder': '+38 (0XX) XXX-XX-XX', clearMaskOnLostFocus: false, showMaskOnHover: false });
    const tel = document.querySelectorAll('input[type=tel]');

    tel.forEach((e) => {
        im.mask('input[type=tel]');
        e.addEventListener('focus', () => {
            im.mask('input[type=tel]');
        });
    });

    // Modal windows functions

    const htmlDoc = document.querySelector('html');
    const modalBtns = document.querySelectorAll('.btn__modal');
    const modalWindows = document.querySelectorAll('.modal-window');
    const modalWindowCloses = document.querySelectorAll('.modal-close');
    const modalWindowBodies = document.querySelectorAll('.modal-window__body');

    modalBtns.forEach(function(el) {
        el.addEventListener('click', function(e) {
            e.preventDefault();
            const modalBtnGetAttr = this.getAttribute('data-modal-id');
            modalWindows.forEach(function(elem) {
                const modalId = elem.getAttribute('id'); 
                if (modalBtnGetAttr == modalId) {
                    elem.classList.add('opened');
                    htmlDoc.classList.add('md-show');
                };
            });
        });
    });
    modalWindowCloses.forEach(function(el) {
        el.addEventListener('click', function(e) {
            e.preventDefault();
            modalWindows.forEach(function(elem) {
                elem.classList.remove('opened');
                htmlDoc.classList.remove('md-show');
                document.querySelectorAll('.wpcf7-form').forEach((e) => {
                    e.reset();
                });
                document.querySelectorAll('.wpcf7-form-control-wrap').forEach((e) => {
                    e.classList.remove('ok');
                    e.classList.remove('invalid');
                });
                document.querySelectorAll('.wpcf7-form-control').forEach((e) => {
                    e.classList.remove('ok');
                    e.classList.remove('invalid');
                });
            });
        });
    });
    modalWindowBodies.forEach(function(el) {
        el.addEventListener('click', function(e) {
            e.preventDefault();
            modalWindows.forEach(function(elem) {
                elem.classList.remove('opened');
                htmlDoc.classList.remove('md-show');
            });
        });
    });

    // Swiper slider

    const swiperSlider = new Swiper('.swiper', {
        // Default parameters 
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                allowTouchMove: false,
                spaceBetween: 15,
                width: '254',
                autoplay: false
            },
            // when window width is >= 768px
            768: {
                allowTouchMove: false,
                spaceBetween: 30,
                width: '254',
                autoplay: false
            },
            // when window width is >= 1024px
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 40,
                // Navigation
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                loop: true
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 40,
                // Navigation
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                loop: true
            }
        }
    });
    
    const supportsOrientationChange = 'onorientationchange' in window, orientationEvent = supportsOrientationChange ? 'orientationchange' : 'resize';
    
    window.addEventListener(orientationEvent, function () {
        window.location.reload();
    }, false);

    window.onload = function() {
        swiperSlider.update();
        setTimeout(function () {
            swiperSlider.reInit();
        }, 500);
    }

    let formControlWrap = document.querySelectorAll('.wpcf7-form-control-wrap');
    formControlWrap.forEach(function (e) {
        e.insertAdjacentHTML('afterbegin', '<i class="checkmark"></i><i class="alert"></i>');
    });
    
    const formWrapper =  document.querySelectorAll('.wpcf7');
    const form =  document.querySelectorAll('.wpcf7-form');
    const responseOutput =  document.querySelectorAll('.wpcf7-response-output');
    const textField =  document.querySelectorAll('input[type=text]');
    const telField =  document.querySelectorAll('input[type=tel]');
    const emailField = document.querySelectorAll('input[type=email]');
    
    formWrapper.forEach((e) => {
        e.addEventListener('wpcf7invalid', function () {
            setTimeout(function () {
                responseOutput.forEach((el) => { 
                    el.text = '';
                    el.setAttribute('aria-hidden', 'true');
                });
                form.forEach((el) => {
                    el.setAttribute('data-status', 'init');
                    el.classList.remove('invalid');
                });
                textField.forEach(function (e) {
                    if (e.classList.contains('wpcf7-not-valid')) {
                        e.closest('.wpcf7-form-control-wrap').classList.add('invalid');
                        e.closest('.wpcf7-form-control-wrap').classList.remove('ok');
                    }
                });
                telField.forEach(function (e) {
                    if (e.classList.contains('wpcf7-not-valid')) {
                        e.closest('.wpcf7-form-control-wrap').classList.add('invalid');
                        e.closest('.wpcf7-form-control-wrap').classList.remove('ok');
                    }
                });
                emailField.forEach(function (e) {
                    if (e.classList.contains('wpcf7-not-valid')) {
                        e.closest('.wpcf7-form-control-wrap').classList.add('invalid');
                        e.closest('.wpcf7-form-control-wrap').classList.remove('ok');
                    }
                });
                document.querySelector('.wpcf7-not-valid-tip').text = '';
            }, 3000);
        });
        e.addEventListener('wpcf7mailsent', function() {
            setTimeout(function () { 
                responseOutput.forEach((el) => { 
                    el.text = '';
                    el.setAttribute('aria-hidden', 'true');
                });
                form.forEach((el) => {
                    el.setAttribute('data-status', 'init');
                    el.classList.remove('sent');
                });
                document.querySelectorAll('.wpcf7-form').forEach((e) => {
                    e.reset();
                });
                document.querySelector('.modal-close').click();
            }, 3000);
        });
    });

    textField.forEach(function (el) {
        el.addEventListener('input', function () {
            textField.forEach(function (e) {
                if (e.value.length > 1) {
                    e.setAttribute('aria-invalid', 'false');
                    e.classList.add('ok');
                    e.closest('.wpcf7-form-control-wrap').classList.remove('invalid');
                    e.closest('.wpcf7-form-control-wrap').classList.add('ok');
                } else {
                    e.setAttribute('aria-invalid', 'true');
                    e.classList.remove('ok');
                    e.closest('.wpcf7-form-control-wrap').classList.add('invalid');
                    e.closest('.wpcf7-form-control-wrap').classList.remove('ok');
                }
            });
        });
    });

    telField.forEach(function (el) {
        el.addEventListener('input', () => { 
            telField.forEach(() => {
                const val = el.value.match(/[^0-9]/g) || '';
                if (val.length <= 7) {
                    el.setAttribute('aria-invalid', 'false');
                    el.classList.add('ok');
                    el.closest('.wpcf7-form-control-wrap').classList.remove('invalid');
                    el.closest('.wpcf7-form-control-wrap').classList.add('ok');
                } else {
                    el.setAttribute('aria-invalid', 'true');
                    el.classList.remove('ok');
                    el.closest('.wpcf7-form-control-wrap').classList.add('invalid');
                    el.closest('.wpcf7-form-control-wrap').classList.remove('ok');
                }
            });
        });
    });

    emailField.forEach(function (el) {
        el.addEventListener('input', function () { 
            emailField.forEach(function (e) {
                const pattern = /^[a-z0-9_-]+@[a-z0-9-]+\.[a-z]{2,6}$/i;
                if (e.val != '') {
                    if (e.val.search(pattern) == 0) {
                        e.setAttribute('aria-invalid', 'false').classList.add('ok');
                        e.closest('.wpcf7-form-control-wrap').classList.remove('invalid');
                        e.closest('.wpcf7-form-control-wrap').classList.add('ok');
                    } else {
                        e.setAttribute('aria-invalid', 'true').classList.remove('ok');
                        e.closest('.wpcf7-form-control-wrap').classList.add('invalid');
                        e.closest('.wpcf7-form-control-wrap').classList.remove('ok');
                    }
                } else {
                    e.setAttribute('aria-invalid', 'true').classList.remove('ok');
                    e.closest('.wpcf7-form-control-wrap').classList.add('invalid');
                    e.closest('.wpcf7-form-control-wrap').classList.remove('ok');
                }
            });
        });
    });

    document.addEventListener('wpcf7mailsent', function() {
        // document.querySelectorAll('#submit').forEach(function (e) { 
        //     e.classList.add('is-sent');
        // });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'formSubmission'
        });
    }, false); 


    // Services heading to value function.

    const servicesButtons = document.querySelectorAll('.section__services .item .btn');

    servicesButtons.forEach(function(e) {
        e.addEventListener('click', () => {
            const serviceButtonTitle = e.getAttribute('data-title');
            const hiddenInput = document.querySelector('#service_request .hidden-subject');
            hiddenInput.value = serviceButtonTitle;
        });
    });

});
